const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/logo.png"
    height="40px"
    width="214px"
    {...props}
  />
);

export default Logo;
